<template>
  <div class="m-tournament">
    <div
      :class="[
        'm-tournament--title-bar',
        {
          control: hasControl
        }
      ]"
    >
      <div
        class="m-tournament-left"
        @click="handleCollapse"
      >
        <span
          v-if="hasControl && control.collapse"
          :class="[
            'm-control-btn x-link-active',
            'm-collapse-btn',
            {
              active: visible
            }
          ]"
        >
          <i class="m-icon-trangle right" />
        </span>

        <div
          class="m-tournament--title"
          :class="{
            canjump
          }"
        >
          <div class="m-text">
            <button
              class="btn-link x-link-active"
              @click="jumpToList"
            >
              <img
                v-if="categoryIcon"
                class="category-icon"
                :src="categoryIcon"
                loading="lazy"
              />
              <div class="btn-link-text"><span v-html="categoryName" /> - <span v-html="tournamentName" /></div>
              <div
                v-if="!visible"
                class="m-count"
              >
                ({{ tournament.events.length }})
              </div>
            </button>
          </div>
          <!-- 可点击跳转 -->
          <svg-icon
            v-if="canjump"
            class="jump-trangle right"
            icon-class="icon-arrowright-new"
          />
        </div>
      </div>

      <template v-if="hasControl">
        <IconFavorite
          v-if="control.favourite"
          class="m-favourite-btn"
          :active="tournament.isFavourite"
          @click="handleFavourite"
        />
      </template>
    </div>

    <MatchList
      v-show="visible"
      :list="tournament.events"
      :current-market-id="currentMarketId"
      :is-show-tournament-info="false"
      :is-show-market-line="isShowMarketLine"
      :oddsfiltered="oddsfiltered"
      :keyword="keyword"
      :key-points="keyPoints"
    />
  </div>
</template>

<script>
import toast from 'fe-vui/toast'
import { ADDED_FAVOURITES, REMOVED_FAVOURITES } from '@ms/config/message'
import eventBus from '@ms/utils/event-bus.js'
import { useAuthStore } from '@ms/stores/auth'
import { updateFavouriteLeague } from '@ms/api/match'
import { prefixLink } from '@ms/config/app'
import IconFavorite from '@ms/components/IconFavorite.vue'
import MatchList from './MatchList.vue'
import { debounce } from 'throttle-debounce'

export default {
  components: {
    IconFavorite,
    MatchList
  },
  props: {
    tournament: {
      type: Object,
      default: () => ({})
    },
    currentMarketId: {
      type: [String, Number],
      default: ''
    },
    control: {
      type: Object,
      default: () => ({
        favourite: false,
        collapse: false
      })
    },
    // 是否可点击 tournament name 跳转列表页, 默认不可跳转
    canjump: {
      type: Boolean,
      default: false
    },
    isShowMarketLine: {
      type: Boolean,
      default: true
    },
    warpVisible: {
      type: Boolean,
      default: true
    },
    // 是否需要筛选 odds
    oddsfiltered: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ''
    },
    keyPoints: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: true
    }
  },
  computed: {
    hasControl() {
      return this.control.favourite || this.control.collapse || this.canjump
    },
    categoryName() {
      return this.regFn(this.tournament.category)
    },
    tournamentName() {
      return this.regFn(this.tournament.tournament)
    },
    categoryIcon() {
      return this.tournament.categoryIcon
    }
  },
  watch: {
    warpVisible(newV) {
      if (!this.control.collapse) return
      this.visible = newV
      this.$emit('collapseAll', this.visible)
    }
  },
  methods: {
    handleFavourite: debounce(1000, true, async function () {
      if (!useAuthStore().loginStatus) {
        return this.$login()
      }

      const { tournamentId, isFavourite } = this.tournament
      try {
        const status = !isFavourite
        await updateFavouriteLeague(tournamentId, status)
        this.$emit('favourite', this.tournament)
        this.$set(this.tournament, 'isFavourite', status)
        const message = status ? ADDED_FAVOURITES : REMOVED_FAVOURITES
        toast(message, { theme: 'light' })
      } catch (error) {
        if (error.login === false) {
          this.$login()
        }
      }
    }),
    regFn(value) {
      const { keyword } = this
      if (keyword) {
        const replaceReg = new RegExp(`(${keyword})`, 'gi')
        return value.replace(replaceReg, '<span class="search-text">$1</span>')
      } else {
        return value
      }
    },
    handleCollapse() {
      if (!this.control.collapse) return
      this.visible = !this.visible
      this.$emit('collapse', this.visible, this.tournament.tournamentId)
    },
    jumpToList() {
      if (!this.canjump) return
      window.mstrace('TournamentEntrance')
      const { tournamentId, category, events } = this.tournament
      const sportName = events[0].sport
      if (this.keyword) eventBus.$emit('search_to_event')
      window.location.href = prefixLink(`/sports/list/${sportName}/${encodeURIComponent(category)}?t=${tournamentId}`)
    }
  }
}
</script>

<style lang="scss">
@use '~wap/common/style/mixin' as mixin;

.m-tournament {
  .m-tournament-left {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
  }

  &--title-bar {
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    padding: 0 5px 0 14px;
    line-height: 36px;

    .m-tournament--title {
      width: 100%;
      flex: 1;
      justify-content: space-between;
      color: #999;
      font-size: 12px;

      .m-text {
        display: flex;
        overflow: hidden;
        width: 90%;
        align-items: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .btn-link {
        display: flex;
        max-width: 100%;
        align-items: center;
        color: #999;
        font-size: 10px;

        .category-icon {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          margin-right: 6px;
        }
      }

      .btn-link-text {
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .m-favourite-btn {
      width: 46px;
      height: 100%;
      flex: none;
      padding: 0 15px;
      margin-left: 6px;
    }

    &.control {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .m-tournament-left {
        width: 70%;
      }

      .m-tournament--title {
        display: flex;
        width: calc(258 / 330 * 100%);
        align-items: center;

        .m-text {
          width: auto;
          max-width: calc(238 / 258 * 100%);

          @include mixin.ellipsis();
        }

        .m-count {
          flex: none;
          margin-left: 6px;
        }

        .search-text {
          color: #ffca27;
        }
      }
    }
  }

  .m-control-btn {
    display: inline-block;
    width: 16px;
    text-align: center;

    .svg-icon {
      margin-top: 6px;
      color: #999;
      font-size: 16px;
      vertical-align: top;
    }
  }

  .m-collapse-btn {
    width: 16px;
    height: 16px;
    flex: none;
    margin-right: 8px;
    line-height: 16px;
    transition: transform 0.2s linear;

    &.active {
      transform: rotate(90deg);
    }

    .m-icon-trangle {
      @include mixin.m-icon-trangle(4px, #999);
    }
  }

  .jump-trangle {
    margin: 0 18px 0 10px;
    font-size: 10px;
  }
}

[data-mode='light'] .m-tournament {
  &--title-bar {
    .m-tournament--title {
      color: #666;

      .btn-link {
        color: #666;
      }
    }
  }

  .m-event-list {
    .m-market-line {
      background: #f0f0f0;
    }
  }
}
</style>
